export const homeItems = [
  {
    value: "pro",
    label: "Pro Academy",
    fields: [
      "category",
      "clickMe",
      "imageURL",
      "name",
      "section",
      "level",
      "streamURL",
      "isMembersOnly",
      "isGoldPlan",
      "type",
      "description",
    ],
  },
  {
    value: "lab",
    label: "Power Lab",
    fields: [
      "category",
      "clickMe",
      "imageURL",
      "name",
      "section",
      "level",
      "streamURL",
      "isMembersOnly",
      "isGoldPlan",
      "type",
      "description",
    ],
  },
];
export const homeItemsMain = [
  {
    value: "recommended",
    label: "Recomendados",
    fields: [
      "category",
      "cdate",
      "description",
      "videoURL",
      "imageURL",
      "name",
      "clickMe",
      "streamURL",
      "tags",
    ],
  },
  {
    value: "events",
    label: "Eventos",
    fields: [
      "category",
      "cdate",
      "description",
      "clickMe",
      "videoURL",
      "imageURL",
      "name",
      "streamURL",
      "tags",
    ],
  },
  {
    value: "success",
    label: "Sistema de Éxito",
    fields: ["cdate", "description", "imageURL", "name", "tags"],
  },
];
export const levelOptions = [
  { value: "beginner", label: "Básico" },
  { value: "intermediate", label: "Intermedio" },
  { value: "advanced", label: "Avanzado" },
];

export const servicesOptions = [
  { value: "trading", label: "Comunidad Trading" },
  { value: "academy", label: "Academia" },
  { value: "market", label: "Mercado Financiero" },
  { value: "ai", label: "Inteligencia Artificial" },
];

export const membershipOptions = [
  { value: "members",  label: "NuCore Access" },
  { value: "goldPlan", label: "NuCore Elite" },
];

export const memberOptions = [
  { value: 0, label: "Sin Plan (Inactivo)" },
  { value: 1, label: "NuCore Access" },
  { value: 2, label: "NuCore Pro" },
  { value: 3, label: "NuCore Elite" },
];

export const bannerType = [
  { value: "trading:forex", label: "Trading / Forex" },
  { value: "trading:futures", label: "Trading / Futuros" },
  { value: "trading:cryptos", label: "Trading / Cryptos" },
  { value: "education:womanofpower", label: "Academia / Woman of Power" },
  {
    value: "education:personaldevelopment",
    label: "Academia / Podcast",
  },
  { value: "education:onemindset", label: "Academia / Mindset" },
];

export const academySectionOptions = [
  { value: "beginner", label: "Básico" },
  { value: "intermediate", label: "Intermedio" },
  { value: "advanced", label: "Avanzado" },
  { value: "pro", label: "Pro" },
  { value: "lab", label: "Lab" },
];

export const idTypes = [
  {
    value: "01",
    label: "Nacional",
    id: 0,
  },
  {
    value: "02",
    label: "Jurídica",
    id: 1,
  },
  {
    value: "03",
    label: "Dimex",
    id: 2,
  },
  {
    value: "04",
    label: "Nite",
    id: 2,
  },
];
